import loggly from '@purecarslabs/signal-utils/loggly'
import {
  DataMiddlewareType,
  ErrorWithResponseType,
  ResponseOrErrorType
} from './types'

// this middleware logs any fetch errors to loggly
const logAPIThrowsMiddleware = (): DataMiddlewareType => async (
  respOrError?: ResponseOrErrorType
): Promise<ResponseOrErrorType> => {
  if (respOrError instanceof Error) {
    const { response } = respOrError as ErrorWithResponseType
    if (response) {
      let body
      const { url, status } = response
      try {
        body = await response.clone().text()
      } catch (err) {
        if (err instanceof Error) {
          body = err.message
        }
      }
      loggly.error({ body, url, status })
    } else {
      loggly.error({ error: respOrError.message })
    }
  }
  return respOrError
}

export default logAPIThrowsMiddleware
